module.exports = __webpack_public_path__ + "static/media/playertable icon-4.3bc2e4b1.svg";